export default class ForceLogoutError extends Error {
    public constructor(message?: string) {
        // Chiamata al costruttore della classe base `Error`
        super(message);

        // Impostare il nome dell'errore
        this.name = new.target.name;

        // Catturare la stack trace (utile per il debugging)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ForceLogoutError);
        }
    }
}
